var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 936,
    viewBox: "0 0 330 936",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_1393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-67.6668 570.412C-208.351 696.49 -412.061 735.243 -546.468 664.987C-741.377 563.12 -788.991 220.204 -582.041 45.1197C-340.972 -158.819 -158.505 -162.807 -32.7124 30.2868C70.4035 188.57 161.484 365.06 -67.6837 570.441L-67.6668 570.412Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-586.931 43.5075C-343.618 -176.09 -149.01 -154.083 -22.0753 34.1234C86.6546 195.335 169.162 376.524 -66.8126 574.616C-211.093 695.961 -422.985 735.42 -559.53 658.383C-748.368 551.818 -782.346 219.861 -586.914 43.4782L-586.931 43.5075Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-591.787 41.8367C-346.431 -193.885 -139.389 -145.442 -11.4552 37.9893C102.998 202.076 176.824 388.018 -65.9584 578.82C-213.823 695.479 -433.951 735.808 -572.564 651.795C-755.503 540.902 -776.061 218.919 -591.775 41.8829L-591.787 41.8367Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-596.66 40.1952C-349.472 -212.164 -129.583 -136.851 -0.864414 41.8384C119.375 208.758 184.456 399.494 -65.1335 583.007C-216.594 694.934 -445.019 736.371 -585.656 645.174C-762.808 530.278 -770.209 217.376 -596.66 40.1952Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-601.533 38.5537C-352.905 -230.982 -119.663 -128.389 9.77261 45.6749C135.955 215.361 192.135 410.959 -64.2624 587.182C-219.336 694.405 -456.112 737.114 -598.685 638.511C-770.206 519.952 -764.682 215.45 -601.533 38.5537Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-606.389 36.883C-356.781 -250.25 -109.604 -119.965 20.3927 49.5409C152.614 221.893 199.796 422.452 -63.4252 591.415C-222.066 693.923 -467.371 738.075 -611.764 631.936C-777.786 509.873 -759.523 213.077 -606.389 36.883Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-611.232 35.2584C-361.17 -270.05 -99.4487 -111.641 31.0298 53.3776C169.353 228.355 207.446 433.9 -62.554 595.59C-224.807 693.395 -478.714 739.182 -624.81 625.303C-785.501 500.028 -754.74 210.409 -611.232 35.2584Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-616.088 33.5876C-366.2 -290.298 -89.1963 -103.417 41.6498 57.2435C186.218 234.732 215.107 445.393 -61.7 599.794C-227.537 692.912 -490.221 740.507 -637.873 618.698C-793.393 490.355 -750.275 207.479 -616.088 33.5876Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-620.961 31.9461C-371.987 -311.06 -78.8805 -95.2345 52.2576 61.0632C203.168 240.964 222.757 456.841 -60.8581 603.952C-230.291 692.338 -501.918 741.957 -650.931 612.019C-801.445 480.823 -746.132 204.363 -620.961 31.9461Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-625.834 30.3047C-378.564 -332.28 -68.4387 -87.1355 62.8777 64.9291C220.257 247.158 230.418 468.335 -60.0039 608.156C-233.05 691.839 -513.78 743.624 -663.994 605.414C-809.628 471.45 -742.282 201.078 -625.834 30.3047Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-630.69 28.6339C-386.131 -353.953 -57.9753 -79.1413 73.5148 68.7658C237.477 253.194 238.097 479.799 -59.1498 612.36C-235.763 691.327 -525.877 745.429 -677.057 598.81C-817.996 462.127 -738.776 197.712 -630.69 28.6339Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.3248 616.547C-238.551 690.811 -538.163 747.359 -690.149 592.189C-826.507 452.916 -735.555 194.298 -635.563 26.9924C-394.719 -376.02 -47.4487 -71.189 84.1349 72.6317C254.747 259.141 245.729 491.276 -58.2955 616.564L-58.3248 616.547Z",
    stroke: "#CBD1D9",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_1393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 902.193,
    height: 898.321,
    fill: "white",
    transform: "translate(-451.839 -294) rotate(30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground1);
export default __webpack_public_path__ + "static/media/background-1.7b2eec5e8e3ad2b4bbb7275ab0bcfabb.svg";
export { ForwardRef as ReactComponent };